/**
 * Человекочитаемые ярлыки для ERROR-кандидатов на страницах «Кандидаты кампании»
 * (CandidatesTab) и таба вакансий (VacanciesTab).
 *
 * TASKNEIROKLYUCH-771/828 синхронизировал enum CandidateStatus с backend, и в фильтре
 * Диалогов ERROR показывается одной опцией без разбивки по причинам. Но в
 * списочных вьюхах рекрутеру всё равно нужна диагностика HH-ошибок прямо в
 * строке — иначе непонятно, рестартовать ли карточку, ждать ли отката лимита
 * или это сетевой сбой. Поэтому маппинг errorCode сохраняется именно для этих
 * двух callsite'ов, а не для фильтра.
 *
 * Возвращает короткий ярлык или null, если не распознали — caller тогда
 * показывает общий «Ошибка».
 */
export function mapErrorCodeToLabel(
  errorCode?: string | null,
  skipReason?: string | null,
): string | null {
  if (skipReason) {
    const reason = skipReason.toLowerCase();
    if (reason.includes('already_applied') && !reason.includes('not_already_applied')) {
      return 'Уже откликался';
    }
  }

  if (!errorCode) {
    return null;
  }

  const named: Record<string, string> = {
    HH_FORBIDDEN: 'Доступ запрещен',
    HH_NO_AUTH: 'Нет авторизации',
    HH_RATE_LIMIT: 'Лимит запросов',
    CONNECTION_FAILED: 'Нет связи',
    TIMEOUT: 'Таймаут',
    IO_ERROR: 'Ошибка ввода',
  };
  if (named[errorCode]) {
    return named[errorCode];
  }

  if (errorCode.startsWith('HH_')) {
    const httpCode = errorCode.slice(3);
    if (httpCode === '401') return 'Нет авторизации';
    if (httpCode === '403') return 'Доступ запрещен';
    if (httpCode === '404') return 'Не найдено';
    if (httpCode === '429') return 'Лимит запросов';
    if (httpCode.startsWith('5')) return 'Ошибка сервера';
    return 'Ошибка ' + httpCode;
  }

  return errorCode.length <= 20 ? errorCode : null;
}
